import MoreBtn from "components/MoreBtn";
import { ReactComponent as TrashIcon } from "assets/images/icons/icon-trash.svg";
import { ReactComponent as ChangeIcon } from "assets/images/icons/icon-edit.svg";
import { ReactComponent as MoreIcon } from "assets/images/icons/icon-more-two.svg";
import Table from "../../../../components/Table";
import style from "../../index.module.css";
import more_icon from "assets/images/icons/icon-more-two.svg";
import { useEffect, useState } from "react";
import apiRequest from "api/axios";
import { returnStringFromArray } from "shared/lib/StringFromArray";

const initialValue = {
  header: [
    {
      content: "№",
      type: "string",
    },
    {
      content: "Название проекта",
      type: "string",
    },
    {
      content: "Участники",
      type: "string",
    },
    {
      content: "Процент",
      type: "string",
    },
    {
      content: "Дата старта",
      type: "string",
    },
    {
      content: "Дата окончания",
      type: "string",
    },
    {
      content: (
        <div>
          <img src={more_icon} />
        </div>
      ),
      type: "html",
    },
  ],
  body: [],
};

const more = [
  {
    text: "Детали",
    image: <ChangeIcon />,
    id: 3,
  },
  {
    text: "Изменить",
    image: <ChangeIcon />,
    id: 1,
  },
  {
    text: "Удалить",
    image: <TrashIcon />,
    id: 2,
  },
];
const collums = [
  "id",
  "title",
  "user",
  "completion_percentage",
  "start_date",
  "end_date",
];


const SubProjects = () => {
  const [data, setData] = useState(initialValue);
  const [pagination, setPagination] = useState({ per_page: 7, page: 1 });
  useEffect(() => {
    (async () => {
      const {
        data: _data,
        headers,
        request,
      } = await apiRequest.get("/project", {
        params: {
          fields: returnStringFromArray(collums),
          "per-page": pagination.per_page,
          page: pagination.page,
          expand: "user",
        },
      });
      const total = headers.get("X-Pagination-Total-Count");
      setPagination((prev) => ({ ...prev, total: Number(total) }));
      let data_order = _data.data.map((item, index) => {
        const res = [];
        for (let i = 0; i < collums.length; i++) {
          const col = collums[i];
          if (col === "id") {
            res.push({
              content: (
                <div className={style.name}>
                  <p>{index + 1}</p>
                </div>
              ),
              type: "html",
            });

            continue;
          }

          if (col in item) {
            res.push({ content: item[col] });
          }
        }

        res.push({
          content: <MoreBtn more={more} more_icon_btn={<MoreIcon />} />,
          type: "html",
        });

        return res;
      });
      setData({ header: initialValue.header, body: data_order });
    })();
  }, [pagination.page]);
  return (
    <div className={`${style.tabel_wrapper} p_0 mt_24`}>
      <Table
        currentPage={pagination.page}
        data={data}
        page={pagination.per_page}
        total={pagination.total}
        changeCurrentPage={(page) =>
          setPagination((prev) => ({ ...prev, page }))
        }
      />
    </div>
  );
};

export default SubProjects;
